/* TODO: update according to reality */

import translate from "src/functions/translate";

function optionsContact(lang: string) {
  return [
    { title: translate(`any`, lang), value: `any` },
    { title: translate(`email`, lang), value: `email` },
    { title: translate(`phone`, lang), value: `phone` },
    { title: translate(`microsoft skype`, lang), value: `skype` },
    {
      title: translate(`facebook messenger`, lang),
      value: `facebook_messenger`,
    },
  ];
}

export default optionsContact;
